






























import Vue from 'vue';
// import DynamicMarquee from "vue-dynamic-marquee";
import HelloWorld from './HelloWorld.vue';
export default Vue.extend({
  name: 'marquee',
  components: {
    // DynamicMarquee,
    // HelloWorld
  },
  props: {
    elNum: {
      type: Number,
      default: 1,
    },
    wrapperHeight: {
      type: Number,
      default: 40,
    },
    wrapperWidth: {
      type: Number,
      default: 25,
    },
    speed: {
      type: Object,
      default() {
        return {
          type: 'pps',
          number: 100,
        };
      },
      validator(val) {
        return (
          val.type &&
          ['pps', 'duration'].includes(val.type) &&
          val.number &&
          !isNaN(val.number)
        );
      },
    },
    repeat: {
      type: Boolean,
      default: true,
    },
    repeatMargin: {
      type: Number,
      default: 10,
    },
    hoverPause: {
      type: Boolean,
      default: true,
    },
    pause: {
      type: Boolean,
      default: false,
    },
    direction: {
      type: String,
      default: 'column',
      validator(val) {
        return ['column', 'row'].includes(val);
      },
    },
    reverse: {
      type: Boolean,
      default: false,
    },
  },
});
